import { API_BASE_REPORT_API_URL } from '../../urls';

export const API_GHG_REPORT_URL = `${API_BASE_REPORT_API_URL}/ghg-reports/draft`;

export const API_GHG_REPORT_QUESTIONS_GET_URL = `${API_GHG_REPORT_URL}/questions`;
export const API_GHG_REPORT_ANSWERS_GET_URL = `${API_GHG_REPORT_URL}/answers`;
export const API_GHG_REPORT_ANSWER_SET_URL = `${API_GHG_REPORT_URL}/answer`;
export const API_GHG_REPORT_DELETE_URL = `${API_GHG_REPORT_URL}/delete`;
